import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function AC_Mobile_view_faq_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='pb-4'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-6'>What is AutoCAD?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          AutoCAD is a software program used to design, form, and shape the 2-D and 3-D images using a computer. AutoCAD provides a set of tools that we can use to complete a detailed design of the product. It also provides an option to create a detailed design layout, which can be automatically drawn using a source model. Autodesk developed this software and first released it in 1982.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What are the basic requirements to run AutoCAD software?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          To run AutoCAD software, the operating system of your computer should support graphic controllers. It is free to use and can be downloaded from its official site. The AutoCAD software is mainly used by Architects, mechanical engineers, mechanical engineering students, etc., across the globe to design the complex infrastructure and identifies flaws before implementing it so that they can save time and resources.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What are the primary uses of AutoCAD?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Architects and professionals mainly use AutoCAD to visualize the imaginary view of the product on a computer system. In AutoCAD, you can easily use the drafter to make the changes in the product before it gets finalized for design. It also facilitates professionals to implement their various ideas and provide various suppliers or clients.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
